
import { atom } from "recoil"

export const AtomCurrentBgAvailable = atom({
    key:'ATOMCURRENTBGAVAILABLE',
    default:[]
})